var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import axios from 'axios';
import { createContext } from 'react';
import { useOktaAuth } from '@okta/okta-react';
var UserRequests = {
    user_check: { method: 'get', type: 'api', path: 'nalauser/hello' },
    get_permissions: { method: 'get', type: 'api', path: 'nalauser/getPermissions' }, // just permissions.
    update_user_settings: { method: 'post', type: 'api', path: 'nalauser/UpdateUserSettings' },
    logout: { method: 'get', type: 'api', path: 'nalauser/logout' }, // clear server cache.
    init_user: { method: 'post', type: 'api', path: 'nalauser/initUser' }, // pulls user and permissions.
    get_user: { method: 'post', type: 'api', path: 'nalauser/getUser' }, // just user.
};
var CoreRequests = {
    confirm_and_translate_url_state: { method: 'post', type: 'api', path: 'nalacore/confirmUrlState' }, // verifies URL state and translate to activeSelection
    translate_dynamic_collection_state: { method: 'post', type: 'api', path: 'nalacore/TranslateDynamicCollectionState' }, // translates url state from a dynamic collection record.
    init_core: { method: 'get', type: 'api', path: 'nalacore/init' },
    init_system: { method: 'get', type: 'api', path: 'nalacore/initSystem' },
};
var ScopeRequests = {
    init_scope: { method: 'get', type: 'api', path: 'nalascope/initScope' },
    get_projects: { method: 'get', type: 'api', path: 'nalascope/getProjects' },
    get_types: { method: 'get', type: 'api', path: 'nalascope/getTypes' },
    get_seasons: { method: 'post', type: 'api', path: 'nalascope/getSeasons' },
    get_episodes: { method: 'post', type: 'api', path: 'nalascope/getEpisodes' },
};
var MediaRequests = {
    init_media_fetch: { method: 'post', type: 'api', path: 'nalaOT/initMediaFetch' },
    page_refinement_fetch: { method: 'post', type: 'api', path: 'nalaOT/pageRefinementFetch' },
    fetch_single_item: { method: 'post', type: 'api', path: 'nalaOT/fetchSingleItem' },
    log_file_audit: { method: 'post', type: 'api', path: 'nalaOT/logFileAudit' },
    download_preview: { method: 'post', type: 'api', path: 'nalaOT/downloadPreview' },
    download_original: { method: 'post', type: 'api', path: 'nalaOT/downloadOriginal' },
    stream_preview: { method: 'post', type: 'api', path: 'nalaOT/streamPreview', responseType: 'blob', timeout: 0 },
    stream_original: { method: 'post', type: 'api', path: 'nalaOT/streamOriginal', responseType: 'blob', timeout: 0 },
};
var CollectionRequests = {
    add_static_collection: { method: 'post', type: 'api', path: 'nalacollection/AddStaticCollection' },
    update_static_collection: { method: 'post', type: 'api', path: 'nalacollection/UpdateStaticCollection' },
    deactivate_static_collection: { method: 'post', type: 'api', path: 'nalacollection/DeactivateStaticCollection' },
    add_dynamic_collection: { method: 'post', type: 'api', path: 'nalacollection/AddDynamicCollection' },
    update_dynamic_collection: { method: 'post', type: 'api', path: 'nalacollection/UpdateDynamicCollection' },
    deactivate_dynamic_collection: { method: 'post', type: 'api', path: 'nalacollection/DeactivateDynamicCollection' },
};
var BaseRequests = {
    server_version: { method: 'get', type: 'api', path: 'version' }, // request server version for display.
};
var Routes = Object.assign({}, UserRequests, CoreRequests, ScopeRequests, MediaRequests, CollectionRequests, BaseRequests);
export var HttpClientContext = createContext(null);
var extractErrorMessage = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var axErr, data, text, parsed, _a, payload;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!axios.isAxiosError(error)) {
                    return [2 /*return*/, error instanceof Error ? error.message : "Unknown error"];
                }
                axErr = error;
                data = (_b = axErr.response) === null || _b === void 0 ? void 0 : _b.data;
                if (!(data instanceof Blob)) return [3 /*break*/, 4];
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                return [4 /*yield*/, data.text()];
            case 2:
                text = _e.sent();
                if (!text)
                    return [2 /*return*/, axErr.message];
                try {
                    parsed = JSON.parse(text);
                    return [2 /*return*/, (parsed.message ||
                            parsed.detail ||
                            parsed.title ||
                            "Request failed (".concat((_d = (_c = axErr.response) === null || _c === void 0 ? void 0 : _c.status) !== null && _d !== void 0 ? _d : "unknown", ")"))];
                }
                catch (_f) {
                    // non-JSON blob
                    return [2 /*return*/, text];
                }
                return [3 /*break*/, 4];
            case 3:
                _a = _e.sent();
                return [2 /*return*/, axErr.message];
            case 4:
                // Normal JSON error response
                if (data && typeof data === "object") {
                    payload = data;
                    return [2 /*return*/, (payload.message ||
                            payload.detail ||
                            payload.title ||
                            axErr.message)];
                }
                return [2 /*return*/, axErr.message];
        }
    });
}); };
export var HttpClientProvider = function (_a) {
    var children = _a.children;
    var authState = useOktaAuth().authState;
    var client = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
    });
    var perform = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (requestName, payload, timeout) {
            var accessToken, requestParams, errmsg;
            var _a, _b;
            if (requestName === void 0) { requestName = 'user_check'; }
            if (payload === void 0) { payload = {}; }
            if (timeout === void 0) { timeout = 12000; }
            return __generator(this, function (_c) {
                accessToken = (_a = authState === null || authState === void 0 ? void 0 : authState.accessToken) === null || _a === void 0 ? void 0 : _a.accessToken;
                requestParams = Routes[requestName];
                if (requestParams && (authState === null || authState === void 0 ? void 0 : authState.isAuthenticated)) {
                    if (!accessToken) {
                        throw new Error("Missing access token for request \"".concat(requestName, "\""));
                    }
                    return [2 /*return*/, client(__assign({ method: requestParams.method, url: "/".concat(requestParams.type, "/").concat(requestParams.path), data: payload, timeout: (_b = requestParams.timeout) !== null && _b !== void 0 ? _b : timeout, headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            } }, (requestParams.responseType ? { responseType: requestParams.responseType } : {})))
                            .then(function (resp) {
                            return resp;
                        })
                            .catch(function (err) { return __awaiter(void 0, void 0, void 0, function () {
                            var msg;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        console.error("Error in request \"".concat(requestName, "\":"), ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) || err.message);
                                        return [4 /*yield*/, extractErrorMessage(err)];
                                    case 1:
                                        msg = _c.sent();
                                        throw new Error(msg);
                                }
                            });
                        }); })];
                }
                else {
                    errmsg = "Request \"".concat(requestName, "\" cannot run before authentication is ready.");
                    throw new Error(errmsg);
                }
                return [2 /*return*/];
            });
        });
    };
    return (_jsx(HttpClientContext.Provider, { value: { HttpConnect: perform }, children: children }));
};
